import { render, staticRenderFns } from "./ProfileRecent.vue?vue&type=template&id=7838f520&"
import script from "./ProfileRecent.vue?vue&type=script&lang=ts&"
export * from "./ProfileRecent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports